import { useState, useEffect } from 'react';
import '@/App.css';
import { Coins, Download, Shield, Users, Rocket, TrendingUp, Lock, Globe, ChevronDown, Menu, X, ExternalLink } from 'lucide-react';

const LOGO_MAIN = 'https://customer-assets.emergentagent.com/job_website-builder-928/artifacts/ss0hbsis_frontsidelogo.png';
const LOGO_NETWORK = 'https://customer-assets.emergentagent.com/job_website-builder-928/artifacts/3osqgo3f_ChatGPT%20Image%20Mar%2019%2C%202026%2C%2001_04_20%20PM.png';
const LOGO_GENESIS = 'https://customer-assets.emergentagent.com/job_website-builder-928/artifacts/el9k9ea2_backside%20of%20token.png';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', message: '' });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleWhitepaperDownload = () => {
    // Create a text-based whitepaper download
    const whitepaperContent = `
PUFFLOO COIN - WHITEPAPER

1. Introduction
PuffLoo Coin (PFL) is a decentralized digital asset designed to support a future ecosystem of community-driven innovation, digital collectibles, and decentralized financial participation.

2. Vision
To build a trusted decentralized network where digital assets, community participation, and technological innovation converge to create sustainable value.

3. Mission
• Build a strong decentralized community
• Provide transparent tokenomics
• Support innovation through blockchain utilities
• Encourage long-term ecosystem development

4. Token Overview
Token Name: PuffLoo Coin
Symbol: PFL
Blockchain: Compatible with major smart-contract networks
Genesis Year: 2026
Total Supply: 1,000,000,000 tokens

5. Tokenomics
Liquidity Pool: 40%
Community Rewards: 25%
Marketing & Ecosystem Growth: 15%
Development: 10%
Reserve: 5%
Community Initiatives / Charity: 5%

6. Security & Transparency
• Transparent smart contracts
• Community-visible token allocation
• Liquidity lock mechanisms

7. Ecosystem Potential
• NFT collectibles
• Digital merchandise
• Gaming integrations
• Community reward systems

8. Roadmap
Phase 1 – Project launch and community building
Phase 2 – Token deployment and liquidity creation
Phase 3 – Website and ecosystem development
Phase 4 – Partnerships and exchange listings
Phase 5 – Expansion of PuffLoo Network ecosystem

9. Genesis Concept
Genesis Block: 0
Genesis Year: 2026
Founding Message: "JK: Starting a decentralized future together."

10. Conclusion
PuffLoo Coin represents a long-term vision for decentralized innovation and community empowerment.

---
© 2026 PuffLoo Coin. All rights reserved.
Visit: puffloocoin.com
`;
    
    const blob = new Blob([whitepaperContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'PuffLoo_Coin_Whitepaper.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Contract address copied to clipboard!');
    });
  };

  const handleBuyNow = () => {
    setModalContent({
      title: 'Buy PuffLoo Coin (PFL)',
      message: 'contract'
    });
    setShowModal(true);
  };

  const handleJoinCommunity = () => {
    // Open both social media links
    window.open('https://x.com/puffloocoin', '_blank');
    window.open('https://t.me/puffloocoin2026', '_blank');
  };

  return (
    <div className="app-container">
      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)} data-testid="modal-overlay">
          <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="modal-content">
            <button className="modal-close" onClick={() => setShowModal(false)} data-testid="modal-close">×</button>
            <h2 className="text-2xl font-bold text-yellow-400 mb-4">{modalContent.title}</h2>
            
            {modalContent.message === 'contract' ? (
              <div>
                <p className="text-gray-300 mb-6">
                  Purchase PFL tokens directly on Pump.fun:
                </p>
                
                <a 
                  href="https://pump.fun/coin/J7KiKPLCPgFosFUkUY6aEQQu3tUoVC7z6Ca17uu3S6st"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary w-full mb-4 inline-flex items-center justify-center text-lg"
                  data-testid="buy-pumpfun-btn"
                >
                  <span className="text-2xl mr-2">🚀</span>
                  Buy PFL on Pump.fun
                </a>

                <div className="text-center mb-6 p-3 bg-blue-400/10 border border-blue-400/30 rounded-lg">
                  <p className="text-blue-400 text-sm">
                    <span className="font-semibold">New to crypto?</span> Follow our{' '}
                    <button 
                      onClick={() => {
                        setShowModal(false);
                        setTimeout(() => scrollToSection('howtobuy'), 300);
                      }}
                      className="underline hover:text-blue-300"
                    >
                      step-by-step guide
                    </button>
                  </p>
                </div>

                <div className="contract-address-box mb-6">
                  <div className="text-sm text-gray-400 mb-2">Contract Address:</div>
                  <div className="flex items-center gap-2 bg-black/50 p-4 rounded-lg border border-yellow-500/30">
                    <code className="text-yellow-400 text-sm flex-1 break-all">
                      J7KiKPLCPgFosFUkUY6aEQQu3tUoVC7z6Ca17uu3S6st
                    </code>
                    <button 
                      onClick={() => copyToClipboard('J7KiKPLCPgFosFUkUY6aEQQu3tUoVC7z6Ca17uu3S6st')}
                      className="copy-btn"
                      title="Copy address"
                      data-testid="copy-address-btn"
                    >
                      📋
                    </button>
                  </div>
                </div>
                <div className="bg-yellow-400/10 border border-yellow-400/30 rounded-lg p-4 mb-6">
                  <p className="text-yellow-400 font-semibold mb-2">⚠️ Important:</p>
                  <ul className="text-gray-300 text-sm space-y-1">
                    <li>• Only use this address on Solana network</li>
                    <li>• Verify the address before sending</li>
                    <li>• Store your tokens in a secure wallet</li>
                  </ul>
                </div>
                <button className="btn-secondary w-full" onClick={() => setShowModal(false)}>Close</button>
              </div>
            ) : (
              <div>
                <p className="text-gray-300 mb-6">{modalContent.message}</p>
                <button className="btn-primary" onClick={() => setShowModal(false)}>Close</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0b0f1a]/95 backdrop-blur-lg border-b border-yellow-500/20 shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-3">
              <img src={LOGO_MAIN} alt="PuffLoo Coin" className="h-12 w-12 rounded-full" />
              <span className="text-2xl font-bold text-yellow-400">PuffLoo</span>
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              {['About', 'Vision', 'Tokenomics', 'Genesis', 'Roadmap', 'How to Buy', 'Whitepaper'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase().replace(/\s+/g, ''))}
                  className="text-gray-300 hover:text-yellow-400 transition-colors duration-200 font-medium"
                >
                  {item}
                </button>
              ))}
            </div>

            <div className="hidden md:flex space-x-4">
              <button className="btn-primary" data-testid="nav-buy-now-btn" onClick={handleBuyNow}>
                Buy Now
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white"
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-[#0b0f1a]/98 backdrop-blur-lg border-t border-yellow-500/20" data-testid="mobile-menu">
            <div className="px-4 py-6 space-y-4">
              {['About', 'Vision', 'Tokenomics', 'Genesis', 'Roadmap', 'How to Buy', 'Whitepaper'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item.toLowerCase().replace(/\s+/g, ''))}
                  className="block w-full text-left text-gray-300 hover:text-yellow-400 transition-colors py-2"
                >
                  {item}
                </button>
              ))}
              <button className="btn-primary w-full mt-4" onClick={handleBuyNow}>
                Buy Now
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="hero" className="hero-section" data-testid="hero-section">
        <div className="stars"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center space-y-8 animate-fade-in">
            <div className="flex justify-center mb-8">
              <img 
                src={LOGO_MAIN} 
                alt="PuffLoo Coin" 
                className="w-64 h-64 md:w-80 md:h-80 object-contain animate-float"
                data-testid="hero-logo"
              />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 glow-text" data-testid="hero-title">
              PUFFLOO COIN
            </h1>
            <p className="text-2xl md:text-3xl text-yellow-400 font-semibold mb-8" data-testid="hero-tagline">
              The Future of Decentralized Wealth
            </p>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-12">
              A decentralized digital asset designed to support a new generation of blockchain innovation and community participation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button className="btn-primary btn-large" data-testid="hero-buy-btn" onClick={handleBuyNow}>
                <Coins className="mr-2" size={20} />
                Buy PFL Now
              </button>
              <button 
                onClick={() => scrollToSection('whitepaper')}
                className="btn-secondary btn-large"
                data-testid="hero-whitepaper-btn"
              >
                <Download className="mr-2" size={20} />
                Read Whitepaper
              </button>
            </div>
            <div className="mt-12 flex flex-col sm:flex-row gap-8 justify-center items-center text-center">
              <div className="stat-card">
                <div className="text-3xl font-bold text-yellow-400">1B</div>
                <div className="text-gray-400 text-sm">Total Supply</div>
              </div>
              <div className="stat-card">
                <div className="text-3xl font-bold text-yellow-400">2026</div>
                <div className="text-gray-400 text-sm">Genesis Year</div>
              </div>
              <div className="stat-card">
                <div className="text-3xl font-bold text-yellow-400">PFL</div>
                <div className="text-gray-400 text-sm">Token Symbol</div>
              </div>
            </div>
            
            <div className="mt-8 flex justify-center items-center gap-4">
              <span className="text-gray-400 text-sm">Join our community:</span>
              <a 
                href="https://x.com/puffloocoin" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon-hero"
                aria-label="Follow on X/Twitter"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a 
                href="https://t.me/puffloocoin2026" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-icon-hero"
                aria-label="Join Telegram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown size={32} className="text-yellow-400" />
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section-dark" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="about-title">About PuffLoo Coin</h2>
            <div className="title-underline"></div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg text-gray-300 leading-relaxed">
                PuffLoo Coin (PFL) is a decentralized digital asset designed to support a new generation of blockchain innovation and community participation.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                Built on the principles of <span className="text-yellow-400 font-semibold">transparency</span>, <span className="text-yellow-400 font-semibold">security</span>, and <span className="text-yellow-400 font-semibold">long-term sustainability</span>, PuffLoo aims to create a global ecosystem where technology, creativity, and decentralized finance converge.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                The PuffLoo Network represents a vision of the future where digital assets empower communities and drive innovation across borders.
              </p>
            </div>
            <div className="relative">
              <img 
                src={LOGO_NETWORK} 
                alt="PuffLoo Network" 
                className="w-full rounded-2xl shadow-2xl border-2 border-yellow-500/30"
                data-testid="about-image"
              />
            </div>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-8 mt-20">
            <div className="feature-card" data-testid="feature-security">
              <Shield className="text-yellow-400 mb-4" size={48} />
              <h3 className="text-xl font-bold text-white mb-3">Secure & Transparent</h3>
              <p className="text-gray-400">Built with security-first approach and transparent smart contracts</p>
            </div>
            <div className="feature-card" data-testid="feature-community">
              <Users className="text-yellow-400 mb-4" size={48} />
              <h3 className="text-xl font-bold text-white mb-3">Community Driven</h3>
              <p className="text-gray-400">Powered by a strong, engaged community of believers</p>
            </div>
            <div className="feature-card" data-testid="feature-innovation">
              <Rocket className="text-yellow-400 mb-4" size={48} />
              <h3 className="text-xl font-bold text-white mb-3">Innovation First</h3>
              <p className="text-gray-400">Continuous development and ecosystem expansion</p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section id="vision" className="section-light" data-testid="vision-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="vision-title">Our Vision</h2>
            <div className="title-underline"></div>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="vision-card">
              <Globe className="text-yellow-400 mb-6 mx-auto" size={64} />
              <p className="text-2xl md:text-3xl text-white font-semibold mb-8 leading-relaxed">
                "To build a trusted decentralized network where digital assets, community participation, and technological innovation converge to create sustainable value."
              </p>
              <div className="border-t border-yellow-500/30 pt-8 space-y-4">
                <h3 className="text-xl font-bold text-yellow-400 mb-4">Our Mission</h3>
                <ul className="space-y-3 text-gray-300 text-left max-w-2xl mx-auto">
                  <li className="flex items-start">
                    <span className="text-yellow-400 mr-3">•</span>
                    <span>Build a strong decentralized community</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-400 mr-3">•</span>
                    <span>Provide transparent tokenomics</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-400 mr-3">•</span>
                    <span>Support innovation through blockchain utilities</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-400 mr-3">•</span>
                    <span>Encourage long-term ecosystem development</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tokenomics Section */}
      <section id="tokenomics" className="section-dark" data-testid="tokenomics-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="tokenomics-title">Tokenomics</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">Fair and transparent token distribution</p>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Liquidity Pool</span>
                  <span className="text-yellow-400 font-bold">40%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '40%'}}></div>
                </div>
              </div>
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Community Rewards</span>
                  <span className="text-yellow-400 font-bold">25%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '25%'}}></div>
                </div>
              </div>
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Marketing & Ecosystem</span>
                  <span className="text-yellow-400 font-bold">15%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '15%'}}></div>
                </div>
              </div>
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Development</span>
                  <span className="text-yellow-400 font-bold">10%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '10%'}}></div>
                </div>
              </div>
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Reserve</span>
                  <span className="text-yellow-400 font-bold">5%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '5%'}}></div>
                </div>
              </div>
              <div className="tokenomics-item">
                <div className="flex justify-between items-center mb-2">
                  <span className="text-white font-semibold">Community Initiatives / Charity</span>
                  <span className="text-yellow-400 font-bold">5%</span>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" style={{width: '5%'}}></div>
                </div>
              </div>
            </div>
            <div className="space-y-6">
              <div className="info-card">
                <h3 className="text-xl font-bold text-yellow-400 mb-4">Token Details</h3>
                <div className="space-y-3 text-gray-300">
                  <div className="flex justify-between border-b border-gray-700 pb-2">
                    <span>Token Name:</span>
                    <span className="font-semibold text-white">PuffLoo Coin</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-700 pb-2">
                    <span>Symbol:</span>
                    <span className="font-semibold text-white">PFL</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-700 pb-2">
                    <span>Total Supply:</span>
                    <span className="font-semibold text-white">1,000,000,000</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-700 pb-2">
                    <span>Genesis Year:</span>
                    <span className="font-semibold text-white">2026</span>
                  </div>
                  <div className="flex justify-between">
                    <span>Blockchain:</span>
                    <span className="font-semibold text-white">Smart Contract</span>
                  </div>
                </div>
              </div>
              <div className="info-card bg-yellow-400/10 border-yellow-400/30">
                <Lock className="text-yellow-400 mb-3" size={32} />
                <h4 className="font-semibold text-white mb-2">Security Features</h4>
                <ul className="text-sm text-gray-300 space-y-1">
                  <li>✓ Transparent smart contracts</li>
                  <li>✓ Community-visible allocation</li>
                  <li>✓ Liquidity lock mechanisms</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Genesis Block Section */}
      <section id="genesis" className="section-light" data-testid="genesis-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="genesis-title">Genesis Block</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">The Beginning of a Legend</p>
          </div>
          <div className="max-w-5xl mx-auto">
            <div className="genesis-card">
              <img 
                src={LOGO_GENESIS} 
                alt="Genesis Block" 
                className="w-full rounded-xl mb-8 shadow-2xl"
                data-testid="genesis-image"
              />
              <div className="grid md:grid-cols-3 gap-8 text-center">
                <div className="space-y-2">
                  <div className="text-4xl font-bold text-yellow-400">Block 0</div>
                  <div className="text-gray-400">Genesis Block</div>
                  <div className="text-sm text-gray-500">April 26, 2026</div>
                </div>
                <div className="space-y-2">
                  <div className="text-4xl font-bold text-yellow-400">JK</div>
                  <div className="text-gray-400">Founder</div>
                  <div className="text-sm text-gray-500">17.3850° N, 78.4867° E</div>
                </div>
                <div className="space-y-2">
                  <div className="text-4xl font-bold text-yellow-400">1B PFL</div>
                  <div className="text-gray-400">Total Supply</div>
                  <div className="text-sm text-gray-500">Fully Allocated</div>
                </div>
              </div>
              <div className="mt-10 p-6 bg-black/30 rounded-lg border border-yellow-500/30">
                <p className="text-xl md:text-2xl text-yellow-400 font-semibold italic text-center">
                  "JK: Starting a decentralized future together!"
                </p>
                <p className="text-center text-gray-400 mt-4 text-sm">— Founding Message</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ecosystem Section */}
      <section id="ecosystem" className="section-dark" data-testid="ecosystem-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title">Ecosystem Potential</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">Future expansions and utilities</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="ecosystem-card">
              <div className="text-4xl mb-4">🎨</div>
              <h3 className="text-lg font-bold text-white mb-2">NFT Collectibles</h3>
              <p className="text-gray-400 text-sm">Unique digital assets and collections</p>
            </div>
            <div className="ecosystem-card">
              <div className="text-4xl mb-4">🛍️</div>
              <h3 className="text-lg font-bold text-white mb-2">Digital Merchandise</h3>
              <p className="text-gray-400 text-sm">Exclusive PuffLoo branded items</p>
            </div>
            <div className="ecosystem-card">
              <div className="text-4xl mb-4">🎮</div>
              <h3 className="text-lg font-bold text-white mb-2">Gaming Integrations</h3>
              <p className="text-gray-400 text-sm">Play-to-earn gaming experiences</p>
            </div>
            <div className="ecosystem-card">
              <div className="text-4xl mb-4">🎁</div>
              <h3 className="text-lg font-bold text-white mb-2">Reward Systems</h3>
              <p className="text-gray-400 text-sm">Community incentives and benefits</p>
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section id="roadmap" className="section-light" data-testid="roadmap-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="roadmap-title">Roadmap</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">Our journey to decentralized future</p>
          </div>
          <div className="max-w-4xl mx-auto space-y-8">
            <div className="roadmap-card" data-testid="roadmap-phase-1">
              <div className="roadmap-number">1</div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Project Launch</h3>
                <p className="text-gray-400">Foundation setup and community building initiatives</p>
              </div>
            </div>
            <div className="roadmap-card" data-testid="roadmap-phase-2">
              <div className="roadmap-number">2</div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Token Deployment</h3>
                <p className="text-gray-400">Smart contract deployment and liquidity pool creation</p>
              </div>
            </div>
            <div className="roadmap-card" data-testid="roadmap-phase-3">
              <div className="roadmap-number">3</div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Website & Ecosystem</h3>
                <p className="text-gray-400">Official website launch and initial ecosystem development</p>
              </div>
            </div>
            <div className="roadmap-card" data-testid="roadmap-phase-4">
              <div className="roadmap-number">4</div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Partnerships & Listings</h3>
                <p className="text-gray-400">Strategic partnerships and major exchange listings</p>
              </div>
            </div>
            <div className="roadmap-card" data-testid="roadmap-phase-5">
              <div className="roadmap-number">5</div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Network Expansion</h3>
                <p className="text-gray-400">Full PuffLoo Network ecosystem expansion and utilities</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to Buy Section */}
      <section id="howtobuy" className="section-dark" data-testid="howtobuy-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="howtobuy-title">How to Buy PuffLoo (PFL)</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">Simple step-by-step guide for beginners</p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-6 mb-12">
              <div className="how-to-step">
                <div className="step-number">1</div>
                <h3 className="text-xl font-bold text-white mb-2">Install Phantom Wallet</h3>
                <p className="text-gray-400 mb-3">Download for Chrome browser or mobile app</p>
                <a href="https://phantom.app" target="_blank" rel="noopener noreferrer" className="text-yellow-400 text-sm hover:underline">
                  → Download Phantom Wallet
                </a>
              </div>

              <div className="how-to-step">
                <div className="step-number">2</div>
                <h3 className="text-xl font-bold text-white mb-2">Buy SOL (Solana)</h3>
                <p className="text-gray-400 mb-3">Purchase SOL from any exchange</p>
                <p className="text-sm text-gray-500">Popular: Binance, Coinbase, Kraken</p>
              </div>

              <div className="how-to-step">
                <div className="step-number">3</div>
                <h3 className="text-xl font-bold text-white mb-2">Transfer SOL to Phantom</h3>
                <p className="text-gray-400 mb-3">Send your SOL to your Phantom wallet address</p>
                <p className="text-sm text-gray-500">Copy address from Phantom app</p>
              </div>

              <div className="how-to-step">
                <div className="step-number">4</div>
                <h3 className="text-xl font-bold text-white mb-2">Click "Buy PFL on Pump.fun"</h3>
                <p className="text-gray-400 mb-3">Use the buy button on this website</p>
                <button onClick={handleBuyNow} className="text-yellow-400 text-sm hover:underline">
                  → Open Buy Modal
                </button>
              </div>

              <div className="how-to-step">
                <div className="step-number">5</div>
                <h3 className="text-xl font-bold text-white mb-2">Connect Your Wallet</h3>
                <p className="text-gray-400 mb-3">On Pump.fun, connect your Phantom wallet</p>
                <p className="text-sm text-gray-500">Approve the connection request</p>
              </div>

              <div className="how-to-step">
                <div className="step-number">6</div>
                <h3 className="text-xl font-bold text-white mb-2">Enter Amount & Buy</h3>
                <p className="text-gray-400 mb-3">Choose how much SOL to spend</p>
                <p className="text-sm text-gray-500">Click BUY and confirm transaction</p>
              </div>
            </div>

            <div className="text-center bg-gradient-to-r from-yellow-400/20 to-yellow-600/20 border-2 border-yellow-400/40 rounded-2xl p-8">
              <div className="text-6xl mb-4">🎉</div>
              <h3 className="text-3xl font-bold text-yellow-400 mb-3">Done!</h3>
              <p className="text-xl text-white mb-6">You now own PFL tokens!</p>
              <button onClick={handleBuyNow} className="btn-primary btn-large">
                <Coins className="mr-2" size={20} />
                Start Buying Now
              </button>
            </div>

            <div className="mt-12 bg-blue-400/10 border border-blue-400/30 rounded-lg p-6">
              <h4 className="text-blue-400 font-semibold mb-3 flex items-center">
                <span className="text-2xl mr-2">💡</span>
                Pro Tips:
              </h4>
              <ul className="text-gray-300 space-y-2 text-sm">
                <li>• Start with a small amount to test the process</li>
                <li>• Always keep some SOL for transaction fees (0.01 SOL minimum)</li>
                <li>• Double-check the contract address before buying</li>
                <li>• Never share your wallet's recovery phrase with anyone</li>
                <li>• Join our community for support if you need help!</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Whitepaper Section */}
      <section id="whitepaper" className="section-dark" data-testid="whitepaper-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="section-title" data-testid="whitepaper-title">Whitepaper</h2>
            <div className="title-underline"></div>
            <p className="text-gray-400 mt-4 text-lg">Learn everything about PuffLoo Coin</p>
          </div>
          <div className="max-w-4xl mx-auto">
            <div className="whitepaper-card">
              <Download className="text-yellow-400 mb-6 mx-auto" size={64} />
              <h3 className="text-3xl font-bold text-white mb-4">PuffLoo Coin Whitepaper</h3>
              <p className="text-gray-300 mb-8 leading-relaxed">
                Read our comprehensive whitepaper to understand the vision, technology, tokenomics, and roadmap for PuffLoo Coin. Discover how we're building a decentralized future together.
              </p>
              <div className="grid md:grid-cols-2 gap-6 mb-8 text-left">
                <div className="space-y-2">
                  <h4 className="font-semibold text-yellow-400 mb-3">Includes:</h4>
                  <ul className="space-y-2 text-gray-400">
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Complete vision and mission</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Detailed tokenomics breakdown</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Security and transparency measures</span>
                    </li>
                  </ul>
                </div>
                <div className="space-y-2">
                  <h4 className="font-semibold text-yellow-400 mb-3">Also covers:</h4>
                  <ul className="space-y-2 text-gray-400">
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Ecosystem expansion plans</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Complete roadmap timeline</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-yellow-400 mr-2">✓</span>
                      <span>Genesis block information</span>
                    </li>
                  </ul>
                </div>
              </div>
              <button className="btn-primary btn-large" data-testid="download-whitepaper-btn" onClick={handleWhitepaperDownload}>
                <Download className="mr-2" size={20} />
                Download Whitepaper (TXT)
              </button>
              <p className="text-sm text-gray-500 mt-4">Last updated: 2026 | PDF version coming soon</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-cta" data-testid="cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Join the PuffLoo Revolution
          </h2>
          <p className="text-xl text-gray-300 mb-10">
            Be part of the decentralized future. Start your journey with PuffLoo Coin today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn-primary btn-large" data-testid="cta-buy-btn" onClick={handleBuyNow}>
              <Coins className="mr-2" size={20} />
              Buy PFL Now
            </button>
            <button className="btn-secondary btn-large" data-testid="cta-community-btn" onClick={handleJoinCommunity}>
              <Users className="mr-2" size={20} />
              Join Community
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black/50 border-t border-yellow-500/20 py-12" data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <img src={LOGO_MAIN} alt="PuffLoo" className="h-10 w-10 rounded-full" />
                <span className="text-xl font-bold text-yellow-400">PuffLoo Coin</span>
              </div>
              <p className="text-gray-400 text-sm">
                The Future of Decentralized Wealth
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-white mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><button onClick={() => scrollToSection('about')} className="hover:text-yellow-400 transition-colors">About</button></li>
                <li><button onClick={() => scrollToSection('tokenomics')} className="hover:text-yellow-400 transition-colors">Tokenomics</button></li>
                <li><button onClick={() => scrollToSection('roadmap')} className="hover:text-yellow-400 transition-colors">Roadmap</button></li>
                <li><button onClick={() => scrollToSection('whitepaper')} className="hover:text-yellow-400 transition-colors">Whitepaper</button></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold text-white mb-4">Community</h3>
              <div className="flex space-x-4">
                <a 
                  href="https://x.com/puffloocoin" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Twitter/X"
                  data-testid="twitter-link"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                <a 
                  href="https://t.me/puffloocoin2026" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  aria-label="Telegram"
                  data-testid="telegram-link"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                  </svg>
                </a>
              </div>
              <p className="text-gray-400 text-xs mt-4">Join our community!</p>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-gray-500 text-sm">
            <p>© 2026 PuffLoo Coin. All rights reserved.</p>
            <p className="mt-2">Starting a decentralized future together.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;